<template>

</template>



<script >

import { mapState } from 'vuex';
import ConferenceCommon from './conferencecommon.vue';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      
    }
  },
  mixins: [ConferenceCommon],
  props: {
  },
  computed: {
    
  },
  components: {
    
  },
  methods: {
    
  },
  mounted() {
    
  },
   watch: {
    message: function(msg,oldval) {
      if (!msg) return;
      if (!msg.incomingMessageRequest.message) return;
      let body = JSON.parse(msg.incomingMessageRequest.message.body);
      console.log('watching message');
      console.log(body);

      switch (body.type) {
        case 'ConfbridgeWelcome':
          this.channels = body.channels;
          this.activeConferenceId = body.bridge.name;
          this.activeBridge = body.bridge;
          console.log(this.session)
          break;
        case 'ConfbridgeJoin':
          // first join event is my own channel
          if (this.channels.length == 0) {
            this.myChannelId = body.channels[0].id;
          }
          this.channels = this.channels.concat(body.channels);
          break;
        case 'ConfbridgeLeave':
          for (let i=0; i<body.channels.length;i++) {
            let leavingChannel = body.channels[i];
            for (let j=0;j<this.channels.length;j++) {
              let ch = this.channels[j];
              if (leavingChannel.id == ch.id) {
                ch.state = "Terminated";
              }
            }
          }
          break;
        case 'ConfbridgeTalking':
          for (let i=0; i<body.channels.length;i++) {
            let talkingChannel = body.channels[i];
            for (let j=0;j<this.channels.length;j++) {
              let ch = this.channels[j];
              if (talkingChannel.id == ch.id) {
                Vue.set(ch, 'talking_status', talkingChannel.talking_status);
              }
            }
          }
          break;
        case 'ConfbridgeMute':
          console.log('received event for confbridgeMute');
          for (let i=0; i<body.channels.length;i++) {
            let mutedChannel = body.channels[i];
            for (let j=0;j<this.channels.length;j++) {
              let ch = this.channels[j];
              if (mutedChannel.id == ch.id) {
                Vue.set(ch, 'muted', true);
              }
            }
          }
          break;
        case 'ConfbridgeUnmute':
          for (let i=0; i<body.channels.length;i++) {
            let unmutedChannel = body.channels[i];
            for (let j=0;j<this.channels.length;j++) {
              let ch = this.channels[j];
              if (unmutedChannel.id == ch.id) {
                Vue.set(ch, 'muted', false);               
              }
            }
          }
          break;
        case 'RaiseHand':
          let channelId = body.channel;
          for (let j=0;j<this.channels.length;j++) {
            let ch = this.channels[j];
            if (channelId == ch.id) {
              Vue.set(ch, 'handRaised', body.value);               
            }
          }
          break;
      }
    },
    state: function(newState) {
      console.log('State is ' + newState);
      switch (newState) {
        case null:
          this.channels = [];
          this.activeBridge = {};
          this.activeConferenceId = null;
          this.activeSpeakerChannelId = null;
          break;
        case 'Terminated':
          this.channels = [];
          this.activeConferenceId = null;
      }

    }
  },
});

</script>

